/* CarbonPhone B2B – Geraeteliste (cp-device-list) fuer Ankauf/Verkauf-Formulare */
  (() => {
    if (customElements.get('cp-device-list')) return;
    const GRADES = {
      ankauf: ['Neuwertig', 'Wie Neu', 'Sehr Gut', 'Gebraucht', 'Defekt'],
      verkauf: ['Egal / günstigster', 'Neu', 'Neuwertig', 'Wie Neu', 'Sehr Gut', 'Gebraucht']
    };
    const STORAGE = ['', '32 GB', '64 GB', '128 GB', '256 GB', '512 GB', '1 TB'];
    const esc = (v) => String(v).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    customElements.define('cp-device-list', class extends HTMLElement {
      connectedCallback() {
        const mode = this.dataset.mode || 'ankauf';
        this.grades = GRADES[mode] || GRADES.ankauf;
        this.innerHTML = `
          <div class="cp-dl__head" aria-hidden="true"><span>Modell</span><span>Speicher</span><span>Zustand</span><span>Anzahl</span><span></span></div>
          <div class="cp-dl__rows"></div>
          <div class="cp-dl__actions">
            <button type="button" class="cp-dl__add">+ Weiteres Gerät</button>
            <button type="button" class="cp-dl__paste-toggle">Liste aus Excel einfügen</button>
            <span class="cp-dl__sum" aria-live="polite"></span>
          </div>
          <div class="cp-dl__paste" hidden>
            <label><span>Spalten: Modell, Speicher, Zustand, Anzahl – direkt aus Excel kopieren und hier einfügen</span>
            <textarea rows="5" placeholder="iPhone 13\t128 GB\tSehr Gut\t25&#10;Galaxy S22\t256 GB\tWie Neu\t10"></textarea></label>
            <button type="button" class="cp-dl__paste-apply">Übernehmen</button>
          </div>
          <textarea class="cp-dl__out" name="${esc(this.dataset.target)}" hidden></textarea>
          <p class="cp-dl__error" role="alert" hidden>Bitte mindestens ein Gerät mit Modell eintragen.</p>`;
        this.rows = this.querySelector('.cp-dl__rows');
        this.addRow();
        this.querySelector('.cp-dl__add').addEventListener('click', () => this.addRow().querySelector('input').focus());
        const box = this.querySelector('.cp-dl__paste');
        this.querySelector('.cp-dl__paste-toggle').addEventListener('click', () => { box.hidden = !box.hidden; if (!box.hidden) box.querySelector('textarea').focus(); });
        this.querySelector('.cp-dl__paste-apply').addEventListener('click', () => this.importText(box.querySelector('textarea')));
        this.addEventListener('input', () => this.sync());
        this.addEventListener('change', () => this.sync());
        const form = this.closest('form');
        if (form) form.addEventListener('submit', (e) => {
          if (!this.sync()) {
            e.preventDefault();
            this.querySelector('.cp-dl__error').hidden = false;
            this.rows.querySelector('input')?.focus();
          }
        });
        this.sync();
      }
      addRow(v = {}) {
        const row = document.createElement('div');
        row.className = 'cp-dl__row';
        const g = this.grades.map((x) => `<option${x === v.grade ? ' selected' : ''}>${esc(x)}</option>`).join('');
        const st = STORAGE.map((x) => `<option value="${esc(x)}"${x === v.storage ? ' selected' : ''}>${x ? esc(x) : '–'}</option>`).join('');
        row.innerHTML = `
          <input type="text" class="cp-dl__model" placeholder="z. B. iPhone 13" aria-label="Modell" value="${esc(v.model || '')}">
          <select class="cp-dl__storage" aria-label="Speicher">${st}</select>
          <select class="cp-dl__grade" aria-label="Zustand">${g}</select>
          <input type="number" class="cp-dl__qty" min="1" step="1" value="${esc(v.qty || 1)}" aria-label="Anzahl">
          <button type="button" class="cp-dl__del" aria-label="Zeile entfernen">&times;</button>`;
        if (v.storage && !STORAGE.includes(v.storage)) {
          const o = document.createElement('option'); o.value = o.textContent = v.storage; o.selected = true;
          row.querySelector('.cp-dl__storage').appendChild(o);
        }
        row.querySelector('.cp-dl__del').addEventListener('click', () => {
          if (this.rows.children.length > 1) row.remove(); else row.querySelectorAll('input').forEach((i) => (i.value = i.type === 'number' ? 1 : ''));
          this.sync();
        });
        this.rows.appendChild(row);
        return row;
      }
      importText(ta) {
        const lines = ta.value.split(/\r?\n/).map((l) => l.trim()).filter(Boolean);
        if (!lines.length) return;
        const first = this.rows.querySelector('.cp-dl__model');
        if (this.rows.children.length === 1 && first && !first.value) this.rows.innerHTML = '';
        lines.forEach((l) => {
          const c = l.split(/\t|;|\s*,\s*/).map((x) => x.trim());
          if (/^(modell|model|gerät|geraet)$/i.test(c[0])) return; // Kopfzeile
          const grade = this.grades.find((g) => g.toLowerCase() === (c[2] || '').toLowerCase()) || this.grades[0];
          const st = (c[1] || '').replace(/\s*gb$/i, ' GB').replace(/\s*tb$/i, ' TB');
          this.addRow({ model: c[0], storage: st, grade, qty: parseInt(c[3], 10) || 1 });
        });
        ta.value = '';
        ta.closest('.cp-dl__paste').hidden = true;
        this.sync();
      }
      sync() {
        const items = [...this.rows.children].map((r) => ({
          model: r.querySelector('.cp-dl__model').value.trim(),
          storage: r.querySelector('.cp-dl__storage').value,
          grade: r.querySelector('.cp-dl__grade').value,
          qty: Math.max(1, parseInt(r.querySelector('.cp-dl__qty').value, 10) || 1)
        })).filter((x) => x.model);
        const total = items.reduce((a, b) => a + b.qty, 0);
        this.querySelector('.cp-dl__sum').textContent = items.length ? `${items.length} Position${items.length > 1 ? 'en' : ''} · ${total} Gerät${total > 1 ? 'e' : ''}` : '';
        this.querySelector('.cp-dl__out').value = items.map((x) => `${x.qty} x ${x.model}${x.storage ? ' | ' + x.storage : ''} | ${x.grade}`).join('\n') + (items.length ? `\nGesamt: ${total} Geräte` : '');
        if (items.length) this.querySelector('.cp-dl__error').hidden = true;
        return items.length > 0;
      }
    });
  })();
